module.exports = __webpack_public_path__ + "static/media/graphic-not-available-yet.220faeb8.png";